var e={sideNavItem:"lds-side-nav-item",external:"lds-side-nav-item--external",danger:"lds-side-nav-item--danger",disabled:"lds-side-nav-item--disabled",active:"lds-side-nav-item--active"};export{e as default};
